ko.subscribable.fn.kick = function ()
{
    this.valueHasMutated();
}
    ;  